import React, { useState } from "react";
import Box from "@mui/material/Box";
import { alpha } from "@mui/material";
import { styled } from "@mui/material/styles";

import AppMedialViewer from "../../../components/apps/AppMedialViewer";
import { Message } from "../../../types/models/Chat";
import { simpleDate, simpleTime } from "../../../utils/dateUtils";

const SenderMessageWrapper = styled("div")(({ theme }) => {
  return {
    mt: 8,
    display: "flex",
    justifyContent: "flex-end",
    "&:last-of-type": {
      marginBottom: 0,
    },
    "& .message-chat-item": {
      textAlign: "right",
    },
    "& .edit-view": {
      paddingLeft: 0,
      paddingRight: 10,
    },
    "&:hover": {
      "& .message-more-dropdown-link": {
        opacity: 1,
        visibility: "visible",
      },
    },
  };
});

const MessageChat = styled("div")(({ theme, className }) => {
  return {
    display: "inline-flex",
    border: `solid 1px ${theme.palette.grey[200]}`,
    padding: "10px 16px",
    position: "relative",
    fontSize: 14,
    flexDirection: "row-reverse",
    textAlign: "right",
    backgroundColor:
      className === "isImage"
        ? "white"
        : alpha(theme.palette.primary.main, 0.1),
    color: theme.palette.text.secondary,
    borderRadius: 16,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    ".last-chat-message &": {
      borderBottomLeftRadius: 16,
    },
  };
});

interface SenderMessageItemProps {
  item: Message;
  isPreviousSender: boolean;
  isLast: boolean;
}

const SenderMessageItem: React.FC<SenderMessageItemProps> = ({ item }) => {
  const [isOpenImage, setOpenImage] = useState(false);
  const onToggleImage = () => setOpenImage(!isOpenImage);

  const renderTime = (date: Date) => {
    if (date) {
      const today = new Date();
      const todayDate = simpleDate(today);
      const msgDate = simpleDate(date);
      if (todayDate === msgDate) {
        return <span>{simpleTime(date)}</span>;
      } else {
        return (
          <span>
            {simpleDate(date)} {simpleTime(date)}
          </span>
        );
      }
    }
  };

  return (
    <SenderMessageWrapper>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Box sx={{ position: "relative" }} className="message-chat-item">
          <Box
            sx={{
              ml: 0,
              textAlign: "right",
              fontSize: 12,
              color: (theme) => theme.palette.text.secondary,
              display: "block",
              mb: 0.5,
            }}
            component="span"
            className="message-time"
          >
            {renderTime(item.createdAt)}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              flexDirection: "row-reverse",
            }}
          >
            {item.text.isImage ? (
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "flex-end",
                  "& img": {
                    objectFit: "cover",
                    borderRadius: 1,
                    width: "90%",
                    display: "block",
                    marginRight: 0,
                  },
                }}
              >
                <img
                  alt="text"
                  src={item.text?.image?.url}
                  onClick={onToggleImage}
                />
              </Box>
            ) : (
              <MessageChat>
                <Box component="p">{item.text.message}</Box>
              </MessageChat>
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: 5.5,
            ml: 2.5,
          }}
          className="message-chat-sender"
        ></Box>
      </Box>
      <AppMedialViewer
        media={item.text?.image?.url}
        onClose={onToggleImage}
        isOpen={isOpenImage}
      />
    </SenderMessageWrapper>
  );
};

export default SenderMessageItem;
